module.exports = __webpack_public_path__ + "img/Weapon_151.a22bb2c7.png";